export const CapsPresentationPROAM = () => {
    return "";
    /* eslint-disable-next-line no-unreachable */
    return (
        <p style={{fontSize: 14}}>
            <span style={{display: 'inline-block', fontSize: 16, width: '100%', textAlign: 'center', fontWeight: 'bold', color: 'var(--proam-color)'}}>Déroulement Sportif Pro A Messieurs</span><br></br><br></br>
            Les équipes sont composées de 4 ou 5 joueurs. Les joueurs de l’équipe recevante sont désignés par A, B, C, les joueurs de l’équipe adverse sont désignés par X, Y, Z.
            Chaque équipe peut inscrire trois joueurs sur la feuille de rencontre + un remplaçant.
            A l’issue de la 3e partie disputée, les équipes ont la possibilité de remplacer l’un des joueurs par le 4e joueur inscrit en tant que remplaçant.
            Les parties se déroulent au meilleur des cinq manches (trois manches gagnées). La rencontre prend fin dès qu’une des équipes a remporté 3 parties. (Une partie gagnée = 1 point pour l’équipe).<br></br>
            <strong>Exemple :  Equipe A     3- 1      Equipe B</strong><br></br>
            ➔	<strong>L’équipe A remporte trois points dans le championnat</strong><br></br>
            ➔	<strong>L’équipe B remporte un seul point pour le championnat</strong> <br></br>
            <br></br><br></br>

            <span style={{color: 'red', fontWeight: 'bold', paddingLeft: 30}}>A)	La phase régulière</span><br></br>
            Elle se déroule en une phase régulière de 10 équipes sous forme de rencontres aller-retour (18 journées). A l’issue des 18 journées, un classement de 1 à 10 est effectué. 
            L’équipe qui termine à la dernière place du classement est reléguée en division inférieure (PRO B) <br></br><br></br>

            <span style={{color: 'red', fontWeight: 'bold', paddingLeft: 30}}>B)	Les Play-offs (NEW) </span><br></br>
            A l’issue de la phase régulière, les équipes classées de 1 à 4 sont qualifiées aux « play-offs ». Les demi-finales se joueront dans les clubs respectifs en « aller-retour ». La finale se jouera dans un lieu unique en une seule rencontre.<br></br> 
            L’équipe qui remportera la finale des play-offs sera désignée « Champions de France ».  <br></br><br></br>

            <strong>Remarque : Pour participer aux play-offs, le joueur doit participer à 8 rencontres de la phase régulières</strong>

        </p>
    )
}

export const CapsPresentationPROBM = () => {
    return "";
    /* eslint-disable-next-line no-unreachable */
    return (
        <p style={{fontSize: 14}}>
            <span style={{display: 'inline-block', fontSize: 16, width: '100%', textAlign: 'center', fontWeight: 'bold', color: 'var(--proam-color)'}}>Déroulement Sportif Pro B Messieurs</span><br></br><br></br>
            Les équipes sont composées de 4 ou 5 joueurs. Les joueurs de l’équipe recevante sont désignés par A, B, C, les joueurs de l’équipe adverse sont désignés par X, Y, Z.<br></br>
            Chaque équipe peut inscrire trois joueurs sur la feuille de rencontre + un remplaçant.<br></br>
            A l’issue de la 3e partie disputée, les équipes ont la possibilité de remplacer l’un des joueurs par le 4e joueur inscrit en tant que remplaçant.<br></br>
            Les parties se déroulent au meilleur des cinq manches (trois manches gagnées). La rencontre prend fin dès qu’une des équipes a remporté 3 parties. (Une partie gagnée = 1 point pour l’équipe).<br></br>
            <strong>Exemple :  Equipe A     3- 1      Equipe B</strong><br></br>
            	<strong style={{paddingLeft: 30}}>➔ L’équipe A remporte trois points dans le championnat</strong><br></br>
            	<strong style={{paddingLeft: 30}}>➔ L’équipe B remporte un seul point pour le championnat</strong> <br></br><br></br>

            <span style={{color: 'red', fontWeight: 'bold', paddingLeft: 30}}>A)	Première phase régulière </span><br></br><br></br>
            Elle se déroule en poule de 12 équipes sous forme de rencontres « aller » (11 rencontres). A l’issue de cette phase, un classement de 1 à 12 est établi.<br></br><br></br>

            <span style={{color: 'red', fontWeight: 'bold', paddingLeft: 30}}>B)	Deuxième phase régulière</span><br></br><br></br>

            A l’issue des résultats de la première phase régulière, les équipes classées de 1 à 8 sont qualifiées pour une seconde phase répartie en deux poules distinctes : poule A et B (utilisation du système du serpent). Ses rencontres se déroulent cette fois-ci en « aller-retour ».<br></br><br></br>

            A l’issue de cette deuxième phase, un nouveau classement de 1 à 4 est effectué dans les deux poules.<br></br><br></br>

            <strong>REMARQUE : Les équipes finissant 1er,2ème,3ème,4ème lors de la 1ère phase partent avec un avantage de points lors de la 2ème phase. Respectivement 4-3-2-1 points.</strong><br></br><br></br>

            <span style={{color: 'red', fontWeight: 'bold', paddingLeft: 30}}>C)	Les Play-offs </span><br></br><br></br>
            Le 1er de la poule A et le 1er de la poule B se rencontre dans une rencontre unique pour déterminer le vainqueur du championnat Pro B.<br></br>
            Les équipes classées de 2 à 4 de la poule A rencontrent leurs homologues de la poule B en « aller-retour » afin  de déterminer un classement intégral. <br></br>
            <strong>Remarque : Pour participer aux rencontres de Plays-offs, les n°1,2,3 doivent participer à 7 (sur 17) rencontres de la phase régulière. Les n°4 et 5 sont exemptés de cette règle.</strong> <br></br><br></br>

            <span style={{color: 'red', fontWeight: 'bold', paddingLeft: 30}}>D)	Les Play-Down </span><br></br><br></br>
            A l’issue de la 1ère phase régulière, les équipes classées de 9 à 12 sont regroupées dans une poule de 4. Toutes les rencontres se déroulent en « aller-retour ». <br></br>
            A l’issue de cette seconde phase, un nouveau classement de 9 à 12 est effectué<br></br> 
            	<strong style={{paddingLeft: 30}}>➔ Les équipes classées 9 et 10ème : maintien pro B</strong><br></br>
            	<strong style={{paddingLeft: 30}}>➔ Les équipes classées 11 et 12ème : relégation Nationale 1</strong><br></br>

        </p>
    )
}

export const CapsPresentationPROAD = () => {
    return (
        <p>

        </p>
    )
}

export const CapsPresentationPROBD = () => {
    return (
        <p>

        </p>
    )
}